import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAxios from 'vue-axios';
import axios from 'axios';
import store from '@/store/index'
import guest from './middleware/guest'
import password from './middleware/password'
import auth from './middleware/auth'
// import admin from './middleware/admin'
// import approver from './middleware/approver'
import middlewarePipeline from './middlewarePipeline'

Vue.use(VueRouter);
Vue.use(VueAxios, axios);

const routes = [
    {
      path: '/',
      name: 'login',
      meta: { middleware: [ guest ] },
      component: () => import('@/views/auths/Login.vue')
    },
    {
      path: '/password/firstTime',
      name: 'password.firstTime',
      meta: { middleware: [ guest ] },
      component: () => import('@/views/auths/FirstTimeLogin.vue'),
    },
    {
      path: '/password/forgot',
      name: 'password.forgot',
      meta: { middleware: [ guest ] },
      component: () => import('@/views/auths/ForgotPassword.vue'),
    },
    {
      path: '/password/reset/:token',
      name: 'password.reset',
      meta: { middleware: [ guest ] },
      component: () => import('@/views/auths/ResetPassword.vue'),
    },
    {
      path: '/password/expired',
      name: 'password.expired',
      meta: { middleware: [ password ] },
      component: () => import('@/views/auths/PasswordExpired.vue'),
    },

    // Logout
    {
      path: '/logout',
      name: 'logout',
      // meta: { middleware: [ auth ] },
      component: () => import('@/views/auths/Logout.vue')
    },

    // Privacy Policy
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/PrivacyPolicy.vue'),
    },

    // Routes with application navigation layout
    {
      path: '/',
      component: () => import('@/AppLayout.vue'),
      children: [
        // Sample Page for Test
        {
          path: '/formlayout',
          name: 'formlayout',
          component: () => import('@/components/FormLayoutDemo.vue')
        },
        {
          path: '/input',
          name: 'input',
          component: () => import('@/components/InputDemo.vue')
        },
        {
          path: '/button',
          name: 'button',
          component: () => import('@/components/ButtonDemo.vue')
        },
        {
          path: '/table',
          name: 'table',
          component: () => import('@/components/TableDemo.vue')
        },
        {
          path: '/list',
          name: 'list',
          component: () => import('@/components/ListDemo.vue')
        },
        {
          path: '/tree',
          name: 'tree',
          component: () => import('@/components/TreeDemo.vue')
        },
        {
          path: '/panel',
          name: 'panel',
          component: () => import('@/components/PanelsDemo.vue')
        },
        {
          path: '/overlay',
          name: 'overlay',
          component: () => import('@/components/OverlaysDemo.vue')
        },

        // Dashboard
        {
          path: 'dashboard',
          name: 'dashboard',
          meta: { middleware: [ auth ] },
          component: () => import('@/views/Dashboard.vue')
        },

        // Profile Management
        {
          path: 'profile',
          name: 'profile.detail',
          meta: { middleware: [ auth ] },
          component: () => import('@/views/profile/UserProfile.vue')
        },
        {
          path: 'changePassword',
          name: 'profile.changePword',
          meta: { middleware: [ auth ] },
          component: () => import('@/views/profile/ChangePassword.vue')
        },

        // User Management
        {
          path: 'users',
          name: 'users.index',
          meta: { middleware: [ auth ], permissions: ['users.*', 'users.list'] },
          component: () => import('@/views/Users.vue'),
        },

        // System Settings / Options Management (RefCodes)
        {
          path: 'refCodes',
          name: 'refCodes.index',
          meta: { middleware: [ auth ], permissions: ['refCodes.htp.*', 'refCodes.htp.list'] },
          component: () => import('@/views/sysSettings/Options.vue'),
        },

        // System Settings / Password Policy
        {
          path: 'passwordPolicies',
          name: 'sysSettings.pwdPolicies',
          meta: { middleware: [ auth ] },
          component: () => import('@/views/sysSettings/pwdPolicy.vue'),
        },

        // Audit Trail
        {
          path: 'auditTrails',
          name: 'auditTrails.index',
          meta: { middleware: [ auth ], permissions: ['auditTrails.*', 'auditTrails.list'] },
          component: () => import('@/views/AuditTrails.vue'),
        },

        // Customer Management
        {
          path: 'customer',
          name: 'customers.index',
          meta: { middleware: [ auth ], permissions: ['customers.*', 'customers.list'] },
          component: () => import('@/views/customer/Customers.vue')
        },
        {
          path: 'contract',
          name: 'contract.index',
          meta: { middleware: [ auth ], permissions: ['contract.*', 'contract.list'] },
          component: () => import('@/views/customer/Contracts.vue')
        },

        // Transport Management
        {
          path: 'transporters',
          name: 'transporters.index',
          meta: { middleware: [ auth ], permissions: ['transporters.*', 'transporters.list'] },
          component: () => import('@/views/transports/Transporters.vue')
        },
        {
          path: 'vehicles',
          name: 'vehicles.index',
          meta: { middleware: [ auth ], permissions: ['vehicles.*', 'vehicles.list'] },
          component: () => import('@/views/transports/Vehicles.vue')
        },
        {
          path: 'drivers',
          name: 'drivers.index',
          meta: { middleware: [ auth ], permissions: ['drivers.*', 'drivers.list'] },
          component: () => import('@/views/transports/Drivers.vue')
        },

        // Schedule Management
        {
          path: 'schedules',
          name: 'schedules.index',
          meta: { middleware: [ auth ], permissions: ['schedules.*', 'schedules.list'] },
          component: () => import('@/views/Schedule/AllSchedule.vue')
        },

        // Media Tape Management
        {
          path: 'media',
          name: 'mediaCust.index',
          meta: { middleware: [ auth ], permissions: ['media.htp.*', 'media.htp.list', 'media.cust.*', 'media.cust.list'] },
          component: () => import('@/views/Inventory_Management/AllMedia.vue')
        },

        // Media Box Management
        {
          path: 'mediaBox',
          name: 'mediaBox.index',
          meta: { middleware: [ auth ], permissions: ['box.htp.*', 'box.htp.list', 'box.cust.*', 'box.cust.list'] },
          component: () => import('@/views/Inventory_Management/MediaBoxes.vue')
        },

        // Turtle Box Management
        {
          path: 'turtleBox',
          name: 'turtleBox.index',
          meta: { middleware: [ auth ], permissions: ['box.htp.*', 'box.htp.list'] },
          component: () => import('@/views/Inventory_Management/TurtleBoxes.vue')
        },

        // Inventory Management - Offsite Slot Total (HTP)
        {
          path: 'inventoryMng',
          name: 'inventoryMng.index',
          meta: { middleware: [ auth ], permissions: ['media.htp.*', 'media.htp.list', 'media.cust.*', 'media.cust.list'] },
          component: () => import('@/views/Inventory_Management/Media.vue')
        },

        // Inventory Management - Inventory Transaction (HTP)
        {
          path: 'inventoryLog',
          name: 'inventoryLog.index',
          meta: { middleware: [ auth ], permissions: ['media.htp.*', 'media.htp.list', 'media.cust.*', 'media.cust.list'] },
          component: () => import('@/views/Inventory_Management/InventoryLog.vue')
        },

        // Inventory Log (Customer)
        // {
        //   path: 'inventoryLog/customer',
        //   name: 'inventoryLog.cust.index',
        //   meta: { middleware: [ auth ], permissions: ['media.cust.*', 'media.cust.list'] },
        //   component: () => import('@/views/Inventory_Management/CustInventoryLog.vue')
        // },

        // Transaction Management (Check Out)
        {
          path: 'transactions/checkOut/media',
          name: 'transactions.checkOut.media',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.checkOut', 'requests.cust.*', 'requests.cust.checkOut'] },
          component: () => import('@/views/transactions/checkOut/media.vue')
        },
        {
          path: 'transactions/checkOut/mediaBox',
          name: 'transactions.checkOut.mediaBox',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.checkOut', 'requests.cust.*', 'requests.cust.checkOut'] },
          component: () => import('@/views/transactions/checkOut/mediaBox.vue')
        },
        {
          path: 'transactions/checkOut/turtleBox',
          name: 'transactions.checkOut.turtleBox',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.checkOut', 'requests.cust.*', 'requests.cust.checkOut'] },
          component: () => import('@/views/transactions/checkOut/turtleBox.vue')
        },

        // Transaction Management (Check In)
        {
          path: 'transactions/checkIn/media',
          name: 'transactions.checkIn.media',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.checkIn', 'requests.cust.*', 'requests.cust.checkIn'] },
          component: () => import('@/views/transactions/checkIn/media.vue')
        },
        {
          path: 'transactions/checkIn/mediaBox',
          name: 'transactions.checkIn.mediaBox',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.checkIn', 'requests.cust.*', 'requests.cust.checkIn'] },
          component: () => import('@/views/transactions/checkIn/mediaBox.vue')
        },
        {
          path: 'transactions/checkIn/turtleBox',
          name: 'transactions.checkIn.turtleBox',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.checkIn', 'requests.cust.*', 'requests.cust.checkIn'] },
          component: () => import('@/views/transactions/checkIn/turtleBox.vue')
        },

        // Location Management
        {
          path: 'location',
          name: 'location.index',
          meta: { middleware: [ auth ], permissions: ['location.*', 'location.list'] },
          component: () => import('@/views/Location_Management/Configuration.vue')
        },

        // Location Management (Tape Location)
        {
          path: 'tapeLocation',
          name: 'tapeLocation.index',
          meta: { middleware: [ auth ], permissions: ['tapeLocation.*', 'tapeLocation.list'] },
          component: () => import('@/views/Location_Management/TapeLocation.vue')
        },

        // Location Management (Box Location)
        {
          path: 'boxLocation',
          name: 'boxLocation.index',
          meta: { middleware: [ auth ], permissions: ['boxLocation.*', 'boxLocation.list'] },
          component: () => import('@/views/Location_Management/BoxLocation.vue')
        },

        // Request Management
        {
          path: 'requests',
          name: 'requests.index',
          meta: { middleware: [ auth ], permissions: ['requests.htp.*', 'requests.htp.list', 'requests.cust.*', 'requests.cust.custList', 'requests.trans.*', 'requests.trans.list'] },
          component: () => import('@/views/Requests.vue')
        },

        // Route Management
        {
          path: 'route',
          name: 'route.index',
          meta: { middleware: [ auth ], permissions: ['route.htp.*', 'route.htp.list'] },
          component: () => import('@/views/Route_Management/Index.vue')
        },
        {
          path: 'routeConfig',
          name: 'routeConfig.index',
          meta: { middleware: [ auth ], permissions: ['route.htp.*', 'route.htp.list'] },
          component: () => import('@/views/Route_Management/Configuration.vue')
        },

        // Report Module
        {
          path: 'reports',
          name: 'reports.index',
          meta: { middleware: [ auth ], permissions: ['reports.htp.*', 'reports.htp.list','reports.cust.*', 'reports.cust.list'] },
          component: () => import('@/views/Reports.vue'),
        },
      ]
    },

    // Error Pages
    { path: '/403', name: 'error.403', component: () => import('@/pages/Access.vue') },
    { path: '/500', name: 'error.500', component: () => import('@/pages/Error.vue') },

    // If route not found (404)
    { path: '*', component: () => import('@/pages/NotFound.vue') },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior() {
    return {x: 0, y: 0};
  }
})

router.beforeEach(async (to, from, next) => {
  if (!(to.meta.middleware || to.meta.permissions)) {
    process.env.NODE_ENV === 'production' ? null : console.log('[DEBUG] No middleware and permission meta tag defined')
    return await next()
  } else {
    process.env.NODE_ENV === 'production' ? null : console.log('[DEBUG] Middleware or permission meta tag exists')
  }

  const middleware = to.meta.middleware
  const permissions = to.meta.permissions

  const context = {
    to,
    from,
    next,
    store,
    permissions
  }

  return await middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
